// extracted by mini-css-extract-plugin
export default {"wrap":"ReferralView_wrap__P2b0Z","tools":"ReferralView_tools__7m0rl","item":"ReferralView_item__Lltpa","label":"ReferralView_label__oQNno","value":"ReferralView_value__Aepwz"};